module.exports = __webpack_public_path__ + "img/mohu@2x.d829b9a7.png";